import {computed} from "mobx";
import {SPORT_TYPES_ALIAS_NAMES} from "../../../../core/app/consts";
import {AllScoresRoutePageModel} from "./all-scores-route.page-model";

export class AllScoresRoutePageTitleModel extends AllScoresRoutePageModel {
  @computed get title(): String {
    return this.isToday ? this.todayTitle : this.dateTitle
  }

  @computed get todayTitle(): String {
    if(this.isOnTv) {
      return this.onTvTitle
    } else if(this.isLive) {
      return this.liveValue || this.liveTitle
    } else {
      return this.mainValue || this.mainTitle
    }
  }

  @computed get dateTitle(): String {
    if(this.isYesterday) {
      return this.yesterdayValue || this.yesterdayTitle
    } else if(this.isTomorrow) {
      return this.tomorrowValue || this.tomorrowTitle
    } else if(this.isBeforeYesterday) {
      return this.matchResultsValue || this.matchResultsTitle
    } else if(this.isAfterTomorrow) {
      return this.matchFixturesValue || this.matchFixturesTitle
    } else {
      return this.datesTitle
    }
  }

  @computed get mainTitle(): String {
    const titleAliasName = this.isHomePage ? this.terms.HOMEPAGE_TITLE_TEMPLATE : this.terms.SPORT_TYPE_HOME_TITLE_TEMPLATE;

    const mainTitle = titleAliasName?.format({
      "LIVESCORE_MAIN_KEYWORD": this.terms.LIVESCORE_MAIN_KEYWORD,
      "LIVESCORE_WITH_SPORT_TYPE_MAIN00_KEYWORD": this.terms.LIVESCORE_WITH_SPORT_TYPE_MAIN_KEYWORD,
      "SPORT_TYPE": this.sportType?.name
    });

    return mainTitle;
  }

  @computed get liveTitle(): String {
    const liveTitle = this.terms.LIVE_SCORES_TITLE_TEMPLATE?.format({
      "LIVE_SCORES_TERM_IN_TITLE": this.terms.LIVE_SCORES_TERM_IN_TITLE.format({
        "LIVESCORE_MAIN_KEYWORD": this.terms.LIVESCORE_MAIN_KEYWORD,
        "LIVESCORE_WITH_SPORT_TYPE_MAIN_KEYWORD": this.terms.LIVESCORE_WITH_SPORT_TYPE_MAIN_KEYWORD
      }),
      "SPORT_TYPE": this.sportType?.name
    });

    return liveTitle;
  }

  get datesTitle(): String {
    let title = this.terms.HP_SCORES_DATE_TITLE_TEMPLATE.format({
      'DATE': this.shortestDate,
      'HP_SCORES_DATE_TITLE': this.terms.HP_SCORES_DATE_TITLE.format({
        "LIVESCORE_MAIN_KEYWORD": this.terms.LIVESCORE_MAIN_KEYWORD,
        "LIVESCORE_WITH_SPORT_TYPE_MAIN_KEYWORD": this.terms.LIVESCORE_WITH_SPORT_TYPE_MAIN_KEYWORD,
      }),
      "SPORT_TYPE": this.sportType?.name
    });

    return title;
  }

  get yesterdayTitle(): String {
    const title: String = this.terms[`META_TITLE_${SPORT_TYPES_ALIAS_NAMES[this.sportType?.id]}_SPORT_YESTERDAY`]?.format({
      "LIVESCORE_MAIN_KEYWORD": this.terms.LIVESCORE_MAIN_KEYWORD,
      "SPORT_TYPE": this.sportType?.name
    });

    return title;
  }

  get tomorrowTitle(): String {
    const title: String = this.terms[`META_TITLE_${SPORT_TYPES_ALIAS_NAMES[this.sportType?.id]}_SPORT_TOMORROW`]?.format({
      "LIVESCORE_MAIN_KEYWORD": this.terms.LIVESCORE_MAIN_KEYWORD,
      "SPORT_TYPE": this.sportType?.name
    });

    return title;
  }

  get matchResultsTitle(): String {
    const title: String = this.terms[`META_TITLE_${SPORT_TYPES_ALIAS_NAMES[this.sportType?.id]}_SPORT_DATE_PREVIOUS`]?.format({
      "LIVESCORE_MAIN_KEYWORD": this.terms.LIVESCORE_MAIN_KEYWORD,
      "SPORT_TYPE": this.sportType?.name
    });

    return title;
  }

  get matchFixturesTitle(): String {
    const title: String = this.terms[`META_TITLE_${SPORT_TYPES_ALIAS_NAMES[this.sportType?.id]}_SPORT_DATE_NEXT`]?.format({
      "LIVESCORE_MAIN_KEYWORD": this.terms.LIVESCORE_MAIN_KEYWORD,
      "SPORT_TYPE": this.sportType?.name
    });

    return title;
  }

  get onTvTitle() {
    return this.terms.META_TITLE_CROSS_SPORT_TYPE_ON_TV;
  }
}